import React from 'react';

const TextBlock = ({ children, style = {}, ...props }) => {
  return (
    <span
      style={{
        textAlign: 'start',
        display: 'block',
        ...style,
      }}
      {...props}
    >
      {children}
    </span>
  );
};

export default TextBlock;
